export default "__VITE_ASSET__Doey1N1w__"